/**
 * The single full-screen boot spinner. Its look — size, colours, background and
 * spin speed — is a pixel match for the static #app-boot loader in index.html,
 * so when React mounts and this takes over there is no jump: the buyer sees one
 * continuous centered spinner from HTML load → lazy-chunk fetch → session probe.
 * If you retune one, retune the other (index.html #app-boot). Only use this at
 * boot / full-page gates — in-shell route transitions use PageSkeleton so the
 * sidebar stays mounted.
 */
export function FullScreenSpinner() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-slate-50">
      <div
        className="h-8 w-8 animate-spin rounded-full border-[3px] border-brand-200 border-t-brand-600 [animation-duration:0.7s]"
        aria-label="Loading"
        role="status"
      />
    </div>
  );
}
